import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl } from '@angular/forms';
import { AdminService } from '../../services/admin.service';


@Component({
    selector: 'add-departments',
    templateUrl: './add-departments.component.html',
    styleUrls: ['./add-departments.component.css']
})
export class AddDepartments {
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
    allPositions;
    groupList: any;
    selectedGroup = "SG";
    selectedPos = "Select position";
    posObj;
    departmentObj;

    constructor(public activeModal: NgbActiveModal,
        private adminService: AdminService
    ) { }


    ngOnInit() {
        this.adminService.getActivePositions().subscribe(
            (res: any) => {
                this.allPositions = res.body;
            }
        );
        this.adminService.getAllGroups().subscribe(
            (response) => {
                this.groupList = response.body;
            },
        );
    }


    selectGroup(id, name) {
        this.selectedGroup = name;
        this.departmentObj = {
            id: id,
            name: name
        };
    }
    selectPos(id, name) {
        this.selectedPos = name;
        this.posObj = [{
            id: id,
            name: name
        }];
    }

    handleFormSubmit() {
        let data = {
            department: '',
            positions: ''
        };
        data = {
            department: this.departmentObj,
            positions: this.posObj
        };
        this.passEntry.emit(data);
        this.activeModal.close(data);
    }


}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/modals/addDepartments/add-departments.component.ts